import { Settings } from 'luxon'
import { toAppLocale } from '../../../i18n'

export const handleSetLocale = (userData, changeLocale) => {
  if (userData && userData.settings && userData.settings.timeZone) {
    Settings.defaultZone = userData?.settings?.timeZone
  } else {
    Settings.defaultZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  if (userData && userData.settings && userData.settings.language) {
    changeLocale(toAppLocale(userData.settings.language))
  }
}
